<template>
  <div class="m-card-primary m-the-modal-content academy-billing-modal">
    <header class="m-the-modal-header">
      <h5>{{ $t('mEditionBillingAcademyBillingModalProducts.title') }}</h5>
      <AtomButtonTheModalCloseIcon/>
    </header>
    <section class="m-the-modal-section academy-billing-modal-products">
      <p class="academy-billing-modal-products-subtitle">
        {{ element.nombreAcademia }}
        <small>{{ $t('mEditionBillingAcademyBillingModalProducts.subtitle') }}</small>
      </p>
      <ul>
        <li
          v-for="(producto, index) in element.productos"
          :key="index"
        >
          <span class="display-flex-column academy-billing-modal-products-info">
            <span class="ellipsis font-weight-bold">{{ producto.nombre_producto }}</span>
            <small class="academy-billing-modal-products-uuid">{{ producto.id_producto }}</small>
          </span>
          <span class="academy-billing-modal-products-actions">
            <button
              class="a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom"
              :data-tooltip-text="copiado === producto.id_producto
                ? $t('mEditionBillingAcademyBillingModalProducts.tooltip.copied')
                : $t('mEditionBillingAcademyBillingModalProducts.tooltip.copy')"
              type="button"
              @click="copiarUuid(producto.id_producto)"
            >
              <i :class="copiado === producto.id_producto ? 'fas fa-check' : 'far fa-copy'"></i>
            </button>
            <button
              class="a-button-secondary a-button-billing-secondary a-button-icon-rounded a-tooltip-primary a-tooltip-bottom"
              :data-tooltip-text="$t('mEditionBillingAcademyBillingModalProducts.tooltip.filter')"
              type="button"
              @click="filtrarProducto(producto.id_producto)"
            >
              <i class="fas fa-filter"></i>
            </button>
          </span>
        </li>
      </ul>
    </section>
    <footer class="m-the-modal-footer">
      <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionBillingAcademyBillingModalProducts.close')"/>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingAcademyBillingModalProducts',

  data () {
    return {
      copiado: '',
      element: {
        nombreAcademia: '',
        onFilter: null,
        productos: []
      }
    }
  },

  created () {
    this.element = this.$modal.element
  },

  methods: {
    copiarUuid (uuid) {
      navigator.clipboard.writeText(uuid)
        .then(() => {
          this.copiado = uuid
        })
        .catch(() => {
          this.copiado = ''
        })
    },

    filtrarProducto (uuid) {
      if (typeof this.element.onFilter === 'function') {
        this.element.onFilter(uuid)
      }
      this.$modal.closeModal()
    }
  }
}
</script>
